function MoneyMaxMarkIcon({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.6 6.2C8.6 4.8 7.5 3.7 6.1 3.7C4.7 3.7 3.6 4.8 3.6 6.2V16.6C3.6 18 4.7 19.1 6.1 19.1C7.5 19.1 8.6 18 8.6 16.6V6.2Z"
        fill="#212121"
      />
      <path
        opacity="0.5"
        d="M3.6 6.4C3.6 6.4 3.4 7.3 5 8.5L8.6 12.2V16.6L3.6 12.4V6.4Z"
        fill="#212121"
      />
      <path
        d="M20.4 6.1C20.4 4.7 19.3 3.6 17.9 3.6C16.5 3.6 15.4 4.7 15.4 6.1V16.8C15.4 18.2 16.5 19.3 17.9 19.3C19.3 19.3 20.4 18.2 20.4 16.8V6.1Z"
        fill="#212121"
      />
      <path
        opacity="0.5"
        d="M20.4 6.1C20.4 6.1 20.6 7 19 8.2L15.4 11.9V16.3L20.4 12.1V6.1Z"
        fill="#212121"
      />
      <path
        d="M16.2 4.5L10.3 11.2C9.3 12.4 9.4 14 10.6 15C11.8 16 13.4 15.9 14.4 14.7L20.3 8C21.3 6.8 21.2 5.2 20 4.2C18.8 3.2 17.2 3.3 16.2 4.5Z"
        fill="#212121"
      />
      <path
        d="M7.9 4.5C6.9 3.3 5.3 3.2 4.3 4.4C3.3 5.6 3.4 7.2 4.6 8.2L10.5 14.9C11.7 15.9 13.3 16 14.3 14.8C15.3 13.6 15.2 12 14 11L7.9 4.5Z"
        fill="#212121"
      />
    </svg>
  );
}

export default MoneyMaxMarkIcon;
